import { PageHeaderWithBack } from "../../../../Components/Molecules";
import { PixQrReceiveContent } from "./PixQrReceiveContent";

export const PixSales = () => {
  return (
    <div className="w-full">
      <PageHeaderWithBack
        title="Receber por Pix"
        subTitle="Gere um QR Code e compartilhe o código copia e cola para receber pagamentos."
        backTo="/pix"
      />

      <div className="mx-auto max-w-xl">
        <PixQrReceiveContent isActive />
      </div>
    </div>
  );
};
